(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sensei-chat"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wf-sensei-chat')) {
    customElements.define('wf-sensei-chat', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.q = selector => this.querySelector(selector);
        this.panel = this.q('dialog');
        this.launch = this.q('.wfs-launch');
        this.startForm = this.q('.wfs-start');
        this.compose = this.q('.wfs-compose');
        this.messages = this.q('.wfs-messages');
        this.endpoint = this.dataset.endpoint;
        this.history = [];
        this.busy = false;
        this.config = null;
        this.securityToken = '';
        this.restoreSession();
        this.launch.addEventListener('click', () => this.panel.open ? this.closePanel() : this.openPanel());
        this.q('.wfs-close').addEventListener('click', () => this.closePanel());
        this.panel.addEventListener('keydown', event => {
          if (event.key === 'Escape') { event.preventDefault(); this.closePanel(); }
        });
        this.startForm.addEventListener('submit', event => { event.preventDefault(); this.startSession(); });
        this.compose.addEventListener('submit', event => { event.preventDefault(); this.sendMessage(); });
        this.q('.wfs-retry').addEventListener('click', () => this.prepare());
        this.q('.wfs-end').addEventListener('click', () => {
          if (this.busy || !window.confirm('¿Quieres terminar esta conversación?')) return;
          this.resetSession(); this.prepare();
        });
        this.q('#wfs-message').addEventListener('keydown', event => {
          if (event.key === 'Enter' && !event.shiftKey && !event.isComposing && !matchMedia('(pointer: coarse)').matches) {
            event.preventDefault(); if (!this.q('.wfs-send').disabled) this.compose.requestSubmit();
          }
        });
      }
      restoreSession() {
        try {
          const saved = JSON.parse(sessionStorage.getItem('wf-sensei-session-v1') || 'null');
          if (saved && /^[a-f0-9-]{72}$/.test(saved.token) && saved.expires_at > Date.now() / 1000 && ['sensei','soporte'].includes(saved.mode)) {
            this.session = saved;
          }
        } catch {}
      }
      saveSession() {
        try {
          if (this.session) sessionStorage.setItem('wf-sensei-session-v1', JSON.stringify(this.session));
          else sessionStorage.removeItem('wf-sensei-session-v1');
        } catch {}
      }
      resetSession() {
        this.session = null; this.history = []; this.messages.replaceChildren(); this.saveSession(); this.updateView();
      }
      async openPanel() {
        this.panel.show(); this.launch.setAttribute('aria-expanded','true');
        this.q('.wfs-close').focus(); this.updateView();
        if (!this.config || !this.securityToken) await this.prepare();
      }
      closePanel() {
        this.panel.close(); this.launch.setAttribute('aria-expanded','false'); this.launch.focus();
      }
      updateView() {
        const active = Boolean(this.session);
        this.startForm.hidden = active; this.q('.wfs-conversation').hidden = !active; this.compose.hidden = !active;
        this.q('#wfs-title').textContent = this.session?.mode === 'soporte' ? 'Atención al cliente' : 'Sensei IA';
        if (active && !this.messages.children.length) this.bubble('assistant', this.session.mode === 'soporte'
          ? 'Hola, soy el asistente de IA de WarriorFlow. ¿En qué puedo orientarte sobre la tienda? No tengo acceso a tus pedidos; para ayuda personal, escribe a hello@warriorflow.es.'
          : 'Hola, soy Sensei IA. ¿Qué quieres trabajar hoy: tu entrenamiento, una duda de jiu-jitsu o una idea para emprender? No compartas información médica personal.');
        this.q('.wfs-remaining').textContent = active ? `${this.session.remaining} preguntas disponibles · IA` : '';
        this.updateControls();
      }
      updateControls() {
        const ready = Boolean(this.config && this.securityToken && !this.busy);
        this.q('.wfs-begin').disabled = !ready;
        this.q('.wfs-send').disabled = !ready || !this.session || this.session.remaining <= 0;
        this.q('.wfs-end').disabled = this.busy;
        this.q('#wfs-message').disabled = this.busy || Boolean(this.session && this.session.remaining <= 0);
      }
      setError(message = '') {
        this.q('.wfs-error').textContent = message; this.q('.wfs-error').hidden = !message;
      }
      async request(path, body, token) {
        const headers = { 'Content-Type': 'application/json' };
        if (token) headers.Authorization = `Bearer ${token}`;
        let response;
        try { response = await fetch(this.endpoint + path, { method: body ? 'POST' : 'GET', headers,
          body: body ? JSON.stringify(body) : undefined, credentials: 'omit', cache: 'no-store', signal: AbortSignal.timeout(60000) }); }
        catch { throw new Error('No se pudo conectar. Comprueba tu conexión y vuelve a intentarlo.'); }
        let data;
        try { data = await response.json(); } catch { throw new Error('El servidor no ha podido responder. Inténtalo en un momento.'); }
        if (!response.ok) { const error = new Error(data.error || 'No se pudo completar la solicitud.'); error.status = response.status; throw error; }
        return data;
      }
      async loadTurnstile() {
        if (window.turnstile?.render) return;
        if (!window.wfSenseiTurnstileLoader) {
          window.wfSenseiTurnstileLoader = new Promise((resolve, reject) => {
            let settled = false;
            const timer = setTimeout(() => finish(new Error('La verificación no pudo cargarse. Revisa tu conexión o bloqueador de contenido.')), 18000);
            const poll = setInterval(() => { if (window.turnstile?.render) finish(); }, 100);
            const finish = error => { if (settled) return; settled = true; clearTimeout(timer); clearInterval(poll); error ? reject(error) : resolve(); };
            if (!document.querySelector('script[src^="https://challenges.cloudflare.com/turnstile/v0/api.js"]')) {
              const script = document.createElement('script'); script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
              script.async = true; script.onerror = () => finish(new Error('No se pudo cargar la verificación de seguridad.')); document.head.append(script);
            }
          });
        }
        try { await window.wfSenseiTurnstileLoader; }
        catch (error) { window.wfSenseiTurnstileLoader = null; throw error; }
      }
      async prepare() {
        if (this.preparing || this.busy) return;
        this.preparing = true; this.securityToken = ''; this.updateControls(); this.setError();
        this.q('.wfs-retry').hidden = true; this.q('.wfs-status').textContent = 'Preparando conexión segura…';
        try {
          if (!['warriorflow.es','www.warriorflow.es'].includes(location.hostname)) throw new Error('Prueba el chat desde warriorflow.es. La verificación está configurada para ese dominio.');
          if (!this.config) this.config = await this.request('/config');
          await this.loadTurnstile();
          this.renderVerification();
        } catch (error) { this.setError(error.message); this.q('.wfs-status').textContent = ''; this.q('.wfs-retry').hidden = false; }
        finally { this.preparing = false; this.updateControls(); }
      }
      renderVerification() {
        const container = this.q('.wfs-verification');
        this.securityToken = ''; this.updateControls();
        const generation = this.verificationGeneration = (this.verificationGeneration || 0) + 1;
        if (this.widgetId !== undefined) { window.turnstile.remove(this.widgetId); this.widgetId = undefined; }
        container.replaceChildren();
        if (this.session && this.session.remaining <= 0) {
          this.q('.wfs-status').textContent = 'Has completado las preguntas de esta sesión. Gracias por conversar con nosotros.'; return;
        }
        this.q('.wfs-status').textContent = 'Verificando conexión…';
        this.widgetId = window.turnstile.render(container, {
          sitekey: this.config.sitekey, action: this.session ? 'sensei_message' : 'sensei_session',
          theme: 'light', size: matchMedia('(max-width: 359px)').matches ? 'compact' : 'flexible', appearance: 'interaction-only', 'response-field': false,
          callback: token => {
            if (generation !== this.verificationGeneration) return;
            this.securityToken = token; this.q('.wfs-status').textContent = ''; this.q('.wfs-retry').hidden = true; this.updateControls();
          },
          'expired-callback': () => {
            if (generation !== this.verificationGeneration) return;
            this.securityToken = ''; this.updateControls(); this.q('.wfs-status').textContent = 'Renueva la verificación para continuar.'; this.q('.wfs-retry').hidden = false;
          },
          'error-callback': () => {
            if (generation !== this.verificationGeneration) return;
            this.securityToken = ''; this.updateControls(); this.q('.wfs-status').textContent = ''; this.setError('No se pudo verificar la conexión. Pulsa Reintentar conexión.'); this.q('.wfs-retry').hidden = false; return true;
          }
        });
      }
      async startSession() {
        if (this.busy || !this.securityToken || !this.startForm.reportValidity()) return;
        this.busy = true; this.updateControls(); this.setError();
        const mode = this.q('input[name="wfs-mode"]:checked').value;
        try {
          const data = await this.request('/session', { email: this.q('#wfs-email').value.trim(), mode,
            interest: this.q('#wfs-interest').value, privacy_accepted: this.q('#wfs-privacy').checked,
            notice_version: this.config.notice_version, turnstile_token: this.securityToken });
          this.session = { token: data.token, expires_at: data.expires_at, remaining: data.remaining, mode };
          this.q('#wfs-email').value = ''; this.history = []; this.saveSession(); this.updateView();
          this.q('.wfs-scroll').scrollTop = 0; this.q('#wfs-message').focus();
        } catch (error) { this.setError(error.message); }
        finally { this.busy = false; this.renderVerification(); this.updateControls(); }
      }
      bubble(role, text) {
        const box = document.createElement('div'); box.className = `wfs-bubble wfs-bubble-${role}`;
        const name = document.createElement('span'); name.className = 'wfs-bubble-name'; name.textContent = role === 'user' ? 'Tú' : (this.session?.mode === 'soporte' ? 'WarriorFlow · IA' : 'Sensei IA'); box.append(name);
        const content = document.createElement('span'); this.safeText(content, text); box.append(content); this.messages.append(box);
        this.q('.wfs-scroll').scrollTop = this.q('.wfs-scroll').scrollHeight; return box;
      }
      safeText(node, text) {
        const allowed = /https:\/\/(?:www\.)?warriorflow\.es(?:\/[a-zA-Z0-9/_?#=&%.-]*)?|mailto:hello@warriorflow\.es/g;
        let offset = 0;
        for (const match of text.matchAll(allowed)) {
          node.append(document.createTextNode(text.slice(offset, match.index)));
          const value = match[0]; const a = document.createElement('a'); a.href = value;
          a.textContent = value.startsWith('mailto:') ? 'hello@warriorflow.es' : value.replace('https://','');
          a.target = '_blank'; a.rel = 'noopener'; node.append(a); offset = match.index + value.length;
        }
        node.append(document.createTextNode(text.slice(offset)));
      }
      async sendMessage() {
        const input = this.q('#wfs-message'); const message = input.value.trim();
        if (this.busy || !this.session || !this.securityToken || !message || this.session.remaining <= 0) return;
        if (this.session.expires_at <= Date.now() / 1000) { this.resetSession(); this.setError('Tu sesión ha caducado. Puedes iniciar otra conversación.'); await this.prepare(); return; }
        this.busy = true; this.updateControls(); this.setError(); this.q('.wfs-status').textContent = 'Sensei está respondiendo…';
        this.bubble('user', message); input.value = '';
        try {
          const data = await this.request('/chat', { message, history: this.history.slice(-10), turnstile_token: this.securityToken }, this.session.token);
          this.history.push({role:'user', content:message}, {role:'assistant', content:data.answer.slice(0,4000)}); this.history = this.history.slice(-10);
          this.session.remaining = data.remaining; this.saveSession();
          this.bubble('assistant', data.answer + (data.incomplete ? '\n\nLa respuesta alcanzó su límite. Puedes pedir que continúe.' : ''));
        } catch (error) {
          this.session.remaining = Math.max(0, this.session.remaining - 1); this.saveSession();
          this.setError(error.message); input.value = message;
          if (error.status === 401) this.resetSession();
        } finally {
          this.busy = false; this.updateView(); this.renderVerification();
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wf-boa-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wf-boa-gallery')) {
    customElements.define('wf-boa-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) this.controller.abort();

        this.controller = new AbortController();
        this.scope = this.closest('.shopify-section');
                        this.relocateDesigns = () => {
          if (!this.scope) return;

          const pickers =
            this.scope.querySelectorAll('.wf-design-picker');

          for (const picker of pickers) {
            const inputs = [
              ...picker.querySelectorAll('input[type="radio"]')
            ];

            const first = inputs[0];

            if (!first) continue;

            if (
              first.name !== 'properties[Diseño]' &&
              !/^properties\[CAMISETA \d+ - Diseño\]$/.test(first.name)
            ) continue;

            const form =
              first.form ||
              picker.closest('product-form-component')
                ?.querySelector('form[action*="/cart/add"]') ||
              this.scope.querySelector(
                'product-form-component form[action*="/cart/add"]'
              );

            if (!form) continue;

            if (!form.id) {
              form.id = `wf-product-${crypto.randomUUID()}`;
            }

            for (const input of inputs) {
              input.setAttribute('form', form.id);
            }

            let container =
              this.querySelector('.wf-boa-designs');

            if (!container) {
              container = document.createElement('div');
              container.className = 'wf-boa-designs';
              this.append(container);
            }

            if (picker.parentElement !== container) {
              container.append(picker);
            }
                        const grid = picker.querySelector('.wf-design-grid');

            if (
              grid &&
              !grid.parentElement.classList.contains('wf-design-carousel')
            ) {
              const carousel = document.createElement('div');
              carousel.className = 'wf-design-carousel';

              const previous = document.createElement('button');
              const next = document.createElement('button');

              previous.type = next.type = 'button';
              previous.className = next.className = 'wf-design-arrow';

              previous.textContent = '‹';
              next.textContent = '›';

              const title =
                picker.querySelector('legend')?.textContent.trim() ||
                'Diseños';

              previous.setAttribute(
                'aria-label',
                `${title}: ver diseños anteriores`
              );

              next.setAttribute(
                'aria-label',
                `${title}: ver diseños siguientes`
              );

              grid.before(carousel);
              carousel.append(previous, grid, next);

              const updateArrows = () => {
                previous.disabled = grid.scrollLeft <= 2;

                next.disabled =
                  grid.scrollLeft + grid.clientWidth >=
                  grid.scrollWidth - 2;
              };

              const move = (direction) => {
                grid.scrollBy({
                  left:
                    direction *
                    Math.max(100, grid.clientWidth * 0.8),
                  behavior:
                    matchMedia('(prefers-reduced-motion: reduce)').matches
                      ? 'auto'
                      : 'smooth'
                });
              };

              previous.addEventListener('click', () => move(-1));
              next.addEventListener('click', () => move(1));

              grid.addEventListener('scroll', updateArrows, {
                passive: true
              });

              window.addEventListener('resize', updateArrows, {
                signal: this.controller.signal
              });

              requestAnimationFrame(updateArrows);
            }
          }

          this.setupShirtSelector();
          this.setupMobileTitle();
          this.setupPackPresentation();
        };

        this.designObserver?.disconnect();

        this.designObserver = new MutationObserver(() => {
          this.relocateDesigns();
        });

        if (this.scope) {
          this.designObserver.observe(this.scope, {
            childList: true,
            subtree: true
          });
        }

        this.designFrame = requestAnimationFrame(() => {
          this.relocateDesigns();
        });

        const options = { signal: this.controller.signal };

        this.titleMedia = matchMedia('(max-width: 749px)');
        this.titleMedia.addEventListener('change', () => {
          this.setupMobileTitle();
          this.setupPackPresentation();
        }, options);


        this.scope?.addEventListener('invalid', (event) => {
          const picker = event.target.closest?.('.wf-design-picker');
          const index = this.packPickers?.indexOf(picker) ?? -1;

          if (index >= 0) this.activateShirt(index, true);

          const sizeIndex = this.nativeSizes?.indexOf(event.target) ?? -1;
          if (sizeIndex >= 0) {
            event.preventDefault();
            this.activateShirt(sizeIndex, true);
            const proxy = this.querySelector('[data-wf-active-size]');
            proxy?.focus();
          }
        }, { ...options, capture: true });

        this.scope?.addEventListener('change', (event) => {
          if (this.nativeSizes?.includes(event.target)) {
            this.syncSizeControl();
          }
        }, options);


        this.scope?.addEventListener('change', (event) => {
          const input = event.target;

          if (!(input instanceof HTMLInputElement)) return;
          if (input.type !== 'radio') return;
          if (!input.closest('.wf-design-picker')) return;

          if (
            input.name !== 'properties[Diseño]' &&
            !/^properties\[CAMISETA \d+ - Diseño\]$/.test(input.name)
          ) return;

          this.showDesign(input);
        }, options);

        this.addEventListener('click', (event) => {
          const button = event.target.closest('.wf-boa-view');

          if (!button) return;

          if (button.dataset.wfVideoId) {
            this.showVideo(button.dataset.wfVideoId);
          } else {
            this.showImage(button.querySelector('img'), '');
          }
        }, options);

      }

      setupMobileTitle() {
        if (!this.scope || !this.titleMedia) return;

        if (!this.productHeading) {
          const normalize = (text) => text.replace(/\s+/g, ' ').trim();
          const title = normalize(this.dataset.wfProductTitle || '');
          if (!title) return;

          this.productHeading = [
            ...this.scope.querySelectorAll('h1, h2, h3')
          ].find((heading) => !this.contains(heading) &&
            normalize(heading.textContent) === title
          );

          if (!this.productHeading) return;

          this.headingPlaceholder = document.createComment('');
          this.productHeading.before(this.headingPlaceholder);
          this.productHeading.classList.add('wf-boa-mobile-title');
        }

        if (this.titleMedia.matches) {
          if (this.productHeading.parentElement !== this) {
            this.prepend(this.productHeading);
          }
        } else if (this.headingPlaceholder?.parentNode &&
                   this.contains(this.productHeading)) {
          this.headingPlaceholder.after(this.productHeading);
        }
      }

      setupPackPresentation() {
                const singleUnit = this.scope?.querySelector(
          '[data-wf-single-unit-price]'
        );
        const singleBadge = this.scope?.querySelector(
          '[data-wf-single-badges]'
        );

        if (
          singleUnit && singleBadge &&
          this.productHeading && this.titleMedia
        ) {
          if (!this.priceOrigins) this.priceOrigins = new Map();

          for (const element of [singleBadge, singleUnit]) {
            if (!this.priceOrigins.has(element)) {
              const placeholder = document.createComment('');
              element.before(placeholder);
              this.priceOrigins.set(element, placeholder);
            }
          }

          if (this.titleMedia.matches) {
            if (this.productHeading.nextSibling !== singleBadge) {
              this.productHeading.after(singleBadge);
            }
            if (singleBadge.nextSibling !== singleUnit) {
              singleBadge.after(singleUnit);
            }
          } else {
            for (const element of [singleBadge, singleUnit]) {
              const origin = this.priceOrigins.get(element);
              if (
                origin?.parentNode &&
                element.previousSibling !== origin
              ) {
                origin.after(element);
              }
            }
          }
          const sizes = this.scope.querySelector(
            'variant-picker[data-product-id="16250702364997"]'
          );

          const summary = this.scope.querySelector(
            'product-price[data-product-id="16250702364997"] wf-quantity-total'
          ) || this.singleSummary;

          if (sizes && summary) {
            this.singleSummary = summary;

            if (!this.priceOrigins.has(summary)) {
              const placeholder = document.createComment('');
              summary.before(placeholder);
              this.priceOrigins.set(summary, placeholder);
            }

            if (this.titleMedia.matches) {
              if (sizes.nextSibling !== summary) {
                sizes.after(summary);
              }
            } else {
              const origin = this.priceOrigins.get(summary);
              if (
                origin?.parentNode &&
                summary.previousSibling !== origin
              ) {
                origin.after(summary);
              }
            }
          }
          const amount = singleUnit.querySelector('strong');
          if (amount) {
            amount.style.fontSize =
              this.titleMedia.matches ? '26px' : '32px';
          }

          return;
        }
        if (!this.scope || !this.productHeading || !this.titleMedia) return;
        const unit = this.scope.querySelector('[data-wf-pack-unit-price]');
        const badges = this.scope.querySelector('[data-wf-pack-badges]');
        const summary = this.scope.querySelector('wf-quantity-total[data-wf-pack-summary]');
        if (!unit || !badges || !summary || !this.packPickers?.length) return;

        if (!this.priceOrigins) this.priceOrigins = new Map();

        for (const element of [unit, badges, summary]) {
          if (!this.priceOrigins.has(element)) {
            const placeholder = document.createComment('');
            element.before(placeholder);
            this.priceOrigins.set(element, placeholder);
          }
        }

        if (badges.nextSibling !== this.productHeading) {
          this.productHeading.before(badges);
        }

        if (this.titleMedia.matches) {
          if (this.productHeading.nextSibling !== unit) {
            this.productHeading.after(unit);
          }
        } else {
          const origin = this.priceOrigins.get(unit);
          if (unit.parentNode !== origin.parentNode) origin.after(unit);
        }

        if (summary.parentElement !== this) this.append(summary);
      }

      setupShirtSelector() {
        const container = this.querySelector('.wf-boa-designs');
        if (!container) return;

        this.packPickers = [
          ...container.querySelectorAll('.wf-design-picker')
        ].filter((picker) => {
          const input = picker.querySelector('input[type="radio"]');
          return input &&
            /^properties\[CAMISETA \d+ - Diseño\]$/.test(input.name);
        });

        if (this.packPickers.length < 2) return;

        let select = container.querySelector('[data-wf-shirt-selector]');

        if (!select) {
          const label = document.createElement('label');
          label.className = 'wf-boa-shirt-control';
          const text = document.createElement('span');
          text.textContent = 'Escoge la camiseta';
          select = document.createElement('select');
          select.setAttribute('data-wf-shirt-selector', '');
          label.append(text, select);
          container.prepend(label);
        }

        if (select.options.length !== this.packPickers.length) {
          select.replaceChildren();

          this.packPickers.forEach((picker, index) => {
            const input = picker.querySelector('input[type="radio"]');
            const number = input.name.match(/CAMISETA (\d+)/)[1];
            const option = document.createElement('option');
            option.value = String(index);
            option.textContent = `Camiseta ${number}`;
            select.append(option);
          });
        }

        select.onchange = () => {
          this.activateShirt(Number(select.value), true);
        };

        this.setupSizeControl(container, select);
        this.activateShirt(this.activeShirtIndex ?? 0, false);
      }

      setupSizeControl(container, shirtSelect) {
        const normalize = (name) => name.normalize('NFC')
          .toLowerCase().replace(/[\s\u00a0:]/g, '')
          .replace(/[–—]/g, '-');

        const candidates = [
          ...this.scope.querySelectorAll(
            '[data-simple-bundles-options] select[name]'
          )
        ];

        const sizes = this.packPickers.map((picker) => {
          const design = picker.querySelector('input[type="radio"]');
          const number = design.name.match(/CAMISETA (\d+)/)[1];
          const expected = normalize(`properties[CAMISETA ${number} - Talla]`);
          return candidates.find((select) =>
            normalize(select.name) === expected
          );
        });

        if (sizes.some((select) => !select)) return;
        this.nativeSizes = sizes;

        let controls = container.querySelector('.wf-boa-purchase-controls');

        if (!controls) {
          controls = document.createElement('div');
          controls.className = 'wf-boa-purchase-controls';
          const shirtLabel = shirtSelect.closest('label');
          shirtLabel.before(controls);
          controls.append(shirtLabel);
        }

        let sizeSelect = controls.querySelector('[data-wf-active-size]');

        if (!sizeSelect) {
          const label = document.createElement('label');
          label.className = 'wf-boa-shirt-control';
          const text = document.createElement('span');
          text.textContent = 'Talla';
          sizeSelect = document.createElement('select');
          sizeSelect.setAttribute('data-wf-active-size', '');
          label.append(text, sizeSelect);
          controls.append(label);
        }

        sizeSelect.onchange = () => {
          const native = this.nativeSizes?.[this.activeShirtIndex ?? 0];
          if (!native) return;
          native.value = sizeSelect.value;
          native.dispatchEvent(new Event('input', { bubbles: true }));
          native.dispatchEvent(new Event('change', { bubbles: true }));
          this.syncSizeControl();
        };

        for (const native of sizes) {
          native.setAttribute('data-wf-size-hidden', '');
          const label = [...native.parentElement.querySelectorAll('label')]
            .find((candidate) => candidate.htmlFor === native.id);
          label?.setAttribute('data-wf-size-hidden', '');
        }
      }

      syncSizeControl() {
        const native = this.nativeSizes?.[this.activeShirtIndex ?? 0];
        const proxy = this.querySelector('[data-wf-active-size]');
        if (!native || !proxy) return;

        const signature = JSON.stringify([...native.options].map((option) =>
          [option.value, option.textContent, option.disabled]
        ));

        if (proxy.dataset.wfOptions !== signature) {
          proxy.replaceChildren(...[...native.options].map((option) => {
            const copy = document.createElement('option');
            copy.value = option.value;
            copy.textContent = option.value === ''
              ? 'Escoge la talla' : option.textContent;
            copy.disabled = option.disabled;
            return copy;
          }));
          proxy.dataset.wfOptions = signature;
        }

        proxy.value = native.value;
        proxy.disabled = native.disabled;
        proxy.setAttribute('aria-label',
          `Talla de la camiseta ${this.activeShirtIndex + 1}`);
      }

      activateShirt(index, showSelection) {
        if (!this.packPickers?.length) return;

        this.activeShirtIndex = Math.max(
          0, Math.min(index, this.packPickers.length - 1)
        );

        this.packPickers.forEach((picker, pickerIndex) => {
          const hidden = pickerIndex !== this.activeShirtIndex;
          if (picker.hidden !== hidden) picker.hidden = hidden;
        });

        const select = this.querySelector('[data-wf-shirt-selector]');
        if (select) select.value = String(this.activeShirtIndex);

        this.syncSizeControl();

        const picker = this.packPickers[this.activeShirtIndex];
        const grid = picker.querySelector('.wf-design-grid');

        requestAnimationFrame(() => {
          if (this.isConnected) grid?.dispatchEvent(new Event('scroll'));
        });

        if (!showSelection) return;

        const selected = picker.querySelector('input[type="radio"]:checked');
        if (selected) {
          this.showDesign(selected);
        } else {
          this.showImage(this.querySelector('.wf-boa-view img'), '');
        }
      }

      disconnectedCallback() {
        this.clearVideo();
        this.controller?.abort();
        this.designObserver?.disconnect();
        cancelAnimationFrame(this.designFrame);

        if (this.headingPlaceholder?.isConnected && this.productHeading) {
          this.headingPlaceholder.after(this.productHeading);
        }

        this.priceOrigins?.forEach((origin, element) => {
          if (origin.isConnected) origin.after(element);
        });
      }

      clearVideo() {
        const slot = this.querySelector('.wf-boa-video-slot');
        slot?.querySelectorAll('video').forEach((video) => video.pause());
        slot?.replaceChildren();
        if (slot) slot.hidden = true;
      }

      showVideo(id) {
        const template = [...this.querySelectorAll(
          'template[data-wf-video-template]'
        )].find((item) => item.dataset.wfVideoTemplate === id);
        const slot = this.querySelector('.wf-boa-video-slot');
        const main = this.querySelector('.wf-boa-main-image');
        if (!template || !slot || !main) return;

        this.clearVideo();
        slot.append(template.content.cloneNode(true));
        main.hidden = true;
        slot.hidden = false;
        this.querySelector('.wf-boa-image-caption').textContent = '';
      }

      showImage(thumbnail, caption) {
        const main = this.querySelector('.wf-boa-main-image');

        if (!thumbnail || !main) return;

        this.clearVideo();
        main.hidden = false;

        const url = new URL(
          thumbnail.currentSrc || thumbnail.src,
          location.href
        );

        url.searchParams.set('width', '1600');

        main.removeAttribute('srcset');
        main.src = url.href;
        main.alt = thumbnail.alt;
        main.width = thumbnail.naturalWidth || thumbnail.width;
        main.height = thumbnail.naturalHeight || thumbnail.height;

        this.querySelector('.wf-boa-image-caption').textContent =
          caption;
      }

      showDesign(input) {
        const thumbnail = input.closest('label')?.querySelector('img');

        if (!thumbnail) return;
     const purchaseForm =
       input.form ||
       this.scope?.querySelector(
         'product-form-component form[action*="/cart/add"]'
       );

     if (purchaseForm) {
       let savedDesign = [
         ...purchaseForm.querySelectorAll(
           'input[data-wf-design-property]'
         )
       ].find((field) => field.name === input.name);

       if (!savedDesign) {
         savedDesign = document.createElement('input');
         savedDesign.type = 'hidden';
         savedDesign.name = input.name;
         savedDesign.setAttribute('data-wf-design-property', '');
         purchaseForm.append(savedDesign);
       }

       savedDesign.value = input.value;
     }
        const fieldset = input.closest('fieldset');
        const shirt = input.name.match(/CAMISETA (\d+)/);
        const caption = shirt
          ? `Camiseta ${shirt[1]} — ${input.value}`
          : input.value;

        this.showImage(thumbnail, caption);

        let preview = fieldset.querySelector('.wf-boa-local-preview');

        if (!preview) {
          preview = document.createElement('figure');
          preview.className = 'wf-boa-local-preview';

          preview.append(
            document.createElement('img'),
            document.createElement('figcaption')
          );

          fieldset.querySelector('.wf-design-grid').before(preview);
        }

        const image = preview.querySelector('img');
        const url = new URL(
          thumbnail.currentSrc || thumbnail.src,
          location.href
        );

        url.searchParams.set('width', '900');

        image.src = url.href;
        image.alt = thumbnail.alt;
        image.width = thumbnail.naturalWidth || thumbnail.width;
        image.height = thumbnail.naturalHeight || thumbnail.height;

        preview.querySelector('figcaption').textContent = caption;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wf-boa-team-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wf-boa-team-picker')) {
    customElements.define('wf-boa-team-picker', class extends HTMLElement {
      connectedCallback() {
        if (this.controller && !this.controller.signal.aborted && this.form?.isConnected) return;
        this.controller?.abort();
        this.controller = new AbortController();
        this.scope = this.closest('.shopify-section');
        this.form = this.closest('form') ||
          document.getElementById(this.dataset.wfTeamForm || '');
        this.counts = [...this.querySelectorAll('[data-wf-team-size]')];

        if (!this.scope || !this.form || this.counts.length !== 5) return;

        if (!this.form.id) this.form.id = `wf-team-form-${crypto.randomUUID()}`;
        this.dataset.wfTeamForm = this.form.id;
        this.querySelectorAll('input').forEach(input => {
          input.setAttribute('form', this.form.id);
        });

        const options = { signal: this.controller.signal };
        const panel = this.querySelector('[data-wf-team-panel]');
        const mode = this.querySelector('[data-wf-team-boa]');
        const openPanel = () => {
          panel.hidden = false;
          mode.setAttribute('aria-expanded', 'true');
          requestAnimationFrame(() => {
            this.querySelector('.wf-team-design-grid')?.dispatchEvent(new Event('scroll'));
          });
        };
        this.dataset.mode ||= 'boa';
        this.fileInput = this.querySelector('[data-wf-team-file]');
        const uploadDialog = this.querySelector('[data-wf-upload-dialog]');
        const confirmation = this.querySelector('[data-wf-upload-confirmation]');
        mode.addEventListener('click', () => {
          this.setMode('boa');
          openPanel();
        }, options);
        this.querySelector('[data-wf-team-upload]').addEventListener('click', () => {
          if (this.uploading) return;
          this.fileInput.disabled = false;
          uploadDialog.showModal();
        }, options);
        uploadDialog.addEventListener('close', () => {
          if (this.dataset.mode !== 'upload') this.fileInput.disabled = true;
        }, options);
        this.querySelector('[data-wf-close]').addEventListener('click', () => uploadDialog.close(), options);
        this.querySelector('[data-wf-confirm-file]').addEventListener('click', () => {
          const file = this.fileInput.files[0];
          const error = this.querySelector('[data-wf-file-error]');
          if (!file || !file.size || !/\.(png|jpe?g|pdf)$/i.test(file.name)) {
            error.textContent = 'Selecciona un archivo PNG, JPG o PDF que no esté vacío.';
            return;
          }
          error.textContent = '';
          this.confirmedFile = file;
          this.setMode('upload');
          uploadDialog.close();
          confirmation.showModal();
        }, options);
        this.querySelector('[data-wf-upload-ok]').addEventListener('click', () => {
          confirmation.close();
          openPanel();
          this.counts[0].focus();
        }, options);
        this.fileInput.addEventListener('change', () => {
          this.confirmedFile = null;
          this.sync();
        }, options);
        document.addEventListener('submit', event => {
          if (event.target !== this.form || this.dataset.mode !== 'upload') return;
          event.preventDefault();
          event.stopImmediatePropagation();
          if (this.uploading) return;
          if (!this.sync()) {
            openPanel();
            this.counts[0].reportValidity();
            return;
          }
          this.addUploadedPack();
        }, { ...options, capture: true });
        this.scope.addEventListener('invalid', event => {
          if (this.contains(event.target)) openPanel();
        }, { ...options, capture: true });
        this.scope.addEventListener('change', event => {
          if (event.target?.name === 'quantity') this.sync();
        }, options);
        window.addEventListener('resize', () => this.placeBelowGallery(), options);
                const grid = this.querySelector('.wf-team-design-grid');

        if (grid) {
          let carousel = grid.closest('.wf-team-carousel');

          if (!carousel) {
            carousel = document.createElement('div');
            carousel.className = 'wf-team-carousel';
            grid.before(carousel);

            const previous = document.createElement('button');
            previous.type = 'button';
            previous.className = 'wf-team-arrow';
            previous.dataset.direction = '-1';
            previous.setAttribute('aria-label', 'Ver diseños anteriores');
            previous.textContent = '‹';

            const next = document.createElement('button');
            next.type = 'button';
            next.className = 'wf-team-arrow';
            next.dataset.direction = '1';
            next.setAttribute('aria-label', 'Ver más diseños');
            next.textContent = '›';

            carousel.append(previous, grid, next);
          }

          const arrows = [
            ...carousel.querySelectorAll('.wf-team-arrow')
          ];

          const updateArrows = () => {
            const maximum = Math.max(
              0, grid.scrollWidth - grid.clientWidth
            );

            arrows[0].disabled = grid.scrollLeft <= 2;
            arrows[1].disabled = grid.scrollLeft >= maximum - 2;
          };

          arrows.forEach(button => {
            button.addEventListener('click', () => {
              grid.scrollBy({
                left: Number(button.dataset.direction)
                  * grid.clientWidth * 0.8,
                behavior: window.matchMedia(
                  '(prefers-reduced-motion: reduce)'
                ).matches ? 'instant' : 'smooth'
              });
            }, options);
          });

          grid.addEventListener('scroll', updateArrows, {
            ...options,
            passive: true
          });

          window.addEventListener('resize', updateArrows, options);
          requestAnimationFrame(updateArrows);
        }
        this.addEventListener('change', (event) => {
          const input = event.target;

          if (!(input instanceof HTMLInputElement)) return;
          if (input.name !== 'properties[Diseño del equipo]') return;

          const thumbnail = input.closest('label')?.querySelector('img');
          const gallery = this.scope?.querySelector('wf-boa-gallery');

          if (thumbnail) {
            gallery?.showImage?.(thumbnail, input.value);
          }
        }, options);
        this.addEventListener('input', () => this.sync(), options);
        this.addEventListener('change', () => this.sync(), options);

        this.form.addEventListener('submit', (event) => {
          if (!this.sync()) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.counts[0].reportValidity();
          }
        }, { ...options, capture: true });

        this.observer?.disconnect();
        this.observer = new MutationObserver(() => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => {
            this.sync();
            this.placeBelowGallery();
          });
        });

        this.observer.observe(this.scope, {
          childList: true,
          subtree: true
        });

        this.sync();
        this.frame = requestAnimationFrame(() => this.placeBelowGallery());
      }

      disconnectedCallback() {
        queueMicrotask(() => {
          if (this.isConnected) return;
          this.controller?.abort();
          this.observer?.disconnect();
          cancelAnimationFrame(this.frame);
        });
      }

      placeBelowGallery() {
        const gallery = this.scope?.querySelector('wf-boa-gallery');
        if (!gallery || !this.form?.isConnected) return;
        if (this.parentElement !== gallery) {
          gallery.append(this);
          return;
        }
        const summary = this.scope.querySelector('wf-quantity-total[data-wf-pack-summary]');
        const slot = this.querySelector('[data-wf-team-summary-slot]');
        if (summary && summary.parentElement !== slot) slot.append(summary);

        const badges = this.scope.querySelector('[data-wf-pack-badges]');
        const unit = this.scope.querySelector('[data-wf-pack-unit-price]');
        const title = gallery.productHeading;
        if (!title || !unit || !badges) return;
        if (!this.unitOrigin?.isConnected) {
          this.unitOrigin = document.createComment('');
          unit.before(this.unitOrigin);
        }
        if (badges.nextElementSibling !== title) title.before(badges);
        if (matchMedia('(max-width: 749px)').matches) {
          if (title.nextElementSibling !== unit) title.after(unit);
        } else if (unit.parentNode !== this.unitOrigin.parentNode) {
          this.unitOrigin.after(unit);
        }
      }

      syncDesignProperty() {
        const selected = this.querySelector('input[type="radio"]:checked');
        let mirror = this.form.querySelector('[data-wf-team-design-property]');
        if (!selected && this.dataset.mode !== 'upload') {
          mirror?.remove();
          return;
        }
        if (!mirror) {
          mirror = document.createElement('input');
          mirror.type = 'hidden';
          mirror.name = 'properties[Diseño del equipo]';
          mirror.dataset.wfTeamDesignProperty = '';
          this.form.append(mirror);
        }
        mirror.value = this.dataset.mode === 'upload' ? 'Diseño propio del equipo' : selected.value;
      }

      setMode(mode) {
        if (this.uploading) return;
        this.dataset.mode = mode;
        this.fileInput.disabled = mode !== 'upload';
        this.querySelectorAll('.wf-team-designs input[type="radio"]').forEach(input => {
          input.disabled = mode !== 'boa';
          input.required = mode === 'boa';
        });
        const status = this.querySelector('[data-wf-upload-status]');
        status.hidden = mode !== 'upload';
        status.textContent = mode === 'upload'
          ? `Archivo preparado: ${this.confirmedFile?.name || 'Confirma tu archivo'}. El mismo diseño para las 12 camisetas.` : '';
        this.querySelector('[data-wf-team-panel]').hidden = false;
        this.sync();
      }

      async addUploadedPack() {
        this.uploading = true;
        const status = this.querySelector('[data-wf-upload-status]');
        const controls = [...this.form.querySelectorAll('button[type="submit"]'), ...this.querySelectorAll('.wf-team-mode')];
        const previous = controls.map(control => control.disabled);
        controls.forEach(control => { control.disabled = true; });
        this.setAttribute('aria-busy', 'true');
        status.hidden = false;
        status.textContent = 'Adjuntando el diseño y añadiendo el pack…';
        let added = false;
        let deferred;
        try {
          const { CartLinesUpdateEvent } = await import('@shopify/events');
          const body = new FormData(this.form);
          // Send the actual File, never its name or the browser fake path.
          body.set('properties[Archivo del equipo]', this.confirmedFile, this.confirmedFile.name);
          body.set('properties[Diseño del equipo]', 'Diseño propio del equipo');
          const sections = [...new Set([...document.querySelectorAll('cart-items-component')]
            .map(component => component.dataset.sectionId).filter(Boolean))].slice(0, 5);
          if (sections.length) body.set('sections', sections.join(','));
          body.set('sections_url', location.pathname);
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST', body, credentials: 'same-origin', headers: { Accept: 'application/json' }
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || 'Shopify no ha podido añadir el pack.');
          added = true;
          const cartResponse = await fetch(`${root}cart.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
          if (!cartResponse.ok) throw new Error('No se ha podido actualizar el carrito.');
          const cart = await cartResponse.json();
          const host = this.form.closest('product-form-component') || this;
          deferred = CartLinesUpdateEvent.createPromise();
          // The event must be observed before its promise is resolved.
          host.dispatchEvent(new CartLinesUpdateEvent({
            action: 'add', context: 'product',
            lines: [{ merchandiseId: body.get('id'), quantity: Number(body.get('quantity') || 1) }],
            promise: deferred.promise
          }));
          deferred.resolve({
            cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
            detail: { items: cart.items, source: 'product-form-component', sourceId: host.id || '',
              itemCount: Number(body.get('quantity') || 1), productId: host.dataset.productId || '16262520996165',
              sections: result.sections, didError: false }
          });
          status.textContent = 'Pack añadido. Revisa el archivo adjunto y las tallas en el carrito.';
        } catch (error) {
          status.textContent = added
            ? 'El pack se ha añadido. Abre el carrito para comprobar el archivo y las tallas; no vuelvas a añadirlo.'
            : `No se ha confirmado la incorporación del pack. Revisa el carrito antes de repetir. ${error.message}`;
        } finally {
          this.uploading = false;
          controls.forEach((control, index) => { control.disabled = previous[index]; });
          this.removeAttribute('aria-busy');
        }
      }

      normalize(value) {
        return value.normalize('NFC').toLowerCase()
          .replace(/[–—]/g, '-')
          .replace(/[\s\u00a0:]/g, '');
      }

      sync() {
        if (this.syncing || !this.counts?.length) return false;
        this.syncing = true;

        try {
          this.counts[0].setCustomValidity('');
          this.syncDesignProperty();

          const quantities = this.counts.map(input => input.valueAsNumber);
          const validNumbers = quantities.every(value =>
            Number.isInteger(value) && value >= 0 && value <= 12
          );

          const total = validNumbers
            ? quantities.reduce((sum, value) => sum + value, 0)
            : null;

          const status = this.querySelector('[data-wf-team-count]');
          const message = total === null
            ? 'Introduce cantidades enteras entre 0 y 12.'
            : `Seleccionadas: ${total} de 12`;

          if (status.textContent.trim() !== message) {
            status.textContent = message;
          }

          const candidates = [
            ...this.scope.querySelectorAll('select[name]')
          ];

          const native = Array.from({ length: 12 }, (_, index) =>
            candidates.find(select =>
              this.normalize(select.name) === this.normalize(
                `properties[CAMISETA ${index + 1} - Talla]`
              )
            )
          );
          if (native.every(Boolean)) {
            native.forEach(select => {
              select.style.setProperty('display', 'none', 'important');

              [...(select.labels || [])].forEach(label => {
                label.style.setProperty('display', 'none', 'important');
              });
            });
          }
          let error = '';

          if (!validNumbers) {
            error = 'Usa cantidades enteras entre 0 y 12.';
          } else if (total !== 12) {
            error = 'Selecciona exactamente 12 camisetas entre todas las tallas.';
          } else if (native.some(select => !select)) {
            error = 'Los selectores del pack todavía no están listos. Recarga la página.';
          }

          if (!error && this.dataset.mode === 'upload' &&
              (!this.confirmedFile || this.fileInput.files[0] !== this.confirmedFile)) {
            error = 'Abre Sube tu diseño y confirma el archivo antes de añadir el pack.';
          }

          if (!error) {
            const sizes = this.counts.flatMap((input, index) =>
              Array(quantities[index]).fill(input.dataset.wfTeamSize)
            );

            const selectedOptions = native.map((select, index) =>
              [...select.options].find(option =>
                !option.disabled && (
                  this.normalize(option.value) === this.normalize(sizes[index]) ||
                  this.normalize(option.textContent) === this.normalize(sizes[index])
                )
              )
            );

            if (selectedOptions.some(option => !option)) {
              error = 'Una de las tallas no está disponible. Revisa las cantidades.';
            } else {
              native.forEach((select, index) => {
                if (select.value === selectedOptions[index].value) return;

                select.value = selectedOptions[index].value;
                select.dispatchEvent(new Event('input', { bubbles: true }));
                select.dispatchEvent(new Event('change', { bubbles: true }));
              });

              let summary = this.form.querySelector(
                '[data-wf-team-size-summary]'
              );

              if (!summary) {
                summary = document.createElement('input');
                summary.type = 'hidden';
                summary.name = 'properties[Tallas del equipo]';
                summary.dataset.wfTeamSizeSummary = '';
                this.form.append(summary);
              }

              summary.value = this.counts.map((input, index) =>
                quantities[index]
                  ? `${input.dataset.wfTeamSize}: ${quantities[index]}`
                  : ''
              ).filter(Boolean).join(' · ');
            }
          }

          if (error) {
            this.form.querySelector('[data-wf-team-size-summary]')?.remove();
          }

          this.counts[0].setCustomValidity(error);
          return !error;
        } finally {
          this.syncing = false;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
